/* eslint-disable @typescript-eslint/no-var-requires */
const businessDays = require('business-days-js');

export const isBusinessDay = (date: string): boolean => businessDays().check(date);
